














































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Equipment, EquipmentStatus } from "../models";
import EquipmentCard from "../components/equipment-card.vue";
import * as _ from "lodash";
import { storage, inventoryCollection, statusesCollection, Timestamp } from "../db";
import { MetaInfo } from "vue-meta";
import { getImageUrl } from "../utilities";
import draggable from "vuedraggable";

interface Category {
  text: string;
  value: string;
}

interface Status {
  name: string;
  value?: number;
  count: number;
}

@Component({
  components: {
    EquipmentCard,
    draggable,
  },
  metaInfo(): MetaInfo {
    return {
      title: "Inventory",
    };
  },
})
export default class Home extends Vue {
  @Getter inventory;
  @Getter admin;
  @Getter statuses;
  @Getter tags;

  private getImageUrl = getImageUrl;

  private inventoryFiltered: Array<any> = [];

  get allStatuses() {
    const results = [{ text: "All" }];
    this.statuses.forEach((x) => {
      results.push(x);
    });
    return results;
  }

  get allTags() {
    const results = [{ text: "All" }];
    this.tags.forEach((x) => {
      results.push(x);
    });
    return results;
  }

  private orderMin = 0;

  // Add Dialog
  private dialogAdd = false;
  private addForm = {
    stockNumber: "",
  };
  private addFormValid = false;

  private localStorageName = "inventory-data";
  private data = {
    selectedStatus: "All",
    selectedTag: "All",
    search: "",
    view: 0,
  };

  private inventoryReportHeaders = [
    { text: "Edit", value: "edit", sortable: false },
    { text: "Image", value: "image", sortable: false },
    //{ text: "Name", value: "name" },
    { text: "Year", value: "year" },
    { text: "Make", value: "make" },
    { text: "Model", value: "model" },
    { text: "Status", value: "status.text" },
    { text: "Tags", value: "tags" },
    { text: "VIN", value: "vin" },
    { text: "Stock #", value: "stockNumber" },
    { text: "Price", value: "price" },
    { text: "Delete", value: "delete", sortable: false },
  ];

  async created() {
    // Open Storage
    const result = JSON.parse(
      localStorage.getItem(this.localStorageName) || "{}"
    );
    const fields = ["selectedStatus", "selectedTag", "search", "view"];
    fields.forEach((x) => {
      // eslint-disable-next-line no-prototype-builtins
      if (result.hasOwnProperty(x)) {
        this.data[x] = result[x];
      }
    });

    // Make sure View is valid
    if (this.data.view != 0 && this.data.view != 1 && this.data.view != 2) {
      this.data.view = 0;
    }

    this.setInventoryFiltered();
  }

  async save() {
    localStorage.setItem(this.localStorageName, JSON.stringify(this.data));
    this.setInventoryFiltered();
  }

  async summitAdd() {
    this.dialogAdd = false;
    const isValid = await (this.$refs.addForm as any).validate();

    if (isValid) {
      const results = await inventoryCollection
        .where("stockNumber", "==", this.addForm.stockNumber)
        .limit(1)
        .get();

      // If no item with that stock number exist add it
      if (results.docs.length == 0) {
        await inventoryCollection.add({
          name: "Unknown",
          status: statusesCollection.doc("5t3E8Uj4YhnjeauwGfqk"),
          stockNumber: this.addForm.stockNumber,
          category: "Truck",
          created: Timestamp.now(),
          imagesUpdated: Timestamp.now(),
          order: this.orderMin - 1,
        });
        await this.$router.push(`/inventory/${this.addForm.stockNumber}/edit`);
      } else {
        console.error(
          `Stock Number ${this.addForm.stockNumber} already exists!`
        );
      }
    }
  }

  @Watch("inventory", { immediate: true })
  inventoryUpdated() {
    this.setInventoryFiltered();
    //Set orderMax, used to set order
    const objOrder = _.minBy(this.inventory, "order");
    if (objOrder) {
      this.orderMin = objOrder["order"];
    }
  }

  @Watch("statuses", { immediate: true })
  statusesUpdated() {
    // Make sure Status is valid
    if (!this.statuses.some((x) => x.text == this.data.selectedStatus)) {
      this.data.selectedStatus = "All";
    }
  }

  @Watch("tags", { immediate: true })
  tagsUpdated() {
    // Make sure tag is valid
    if (!this.tags.some((x) => x.text == this.data.selectedTag)) {
      this.data.selectedTag = "All";
    }
  }

  async setInventoryFiltered() {
    this.inventoryFiltered = this.inventory
      .filter((x) => {
        // Search
        if (this.data.search !== "") {
          return Object.keys(x).some((k) => {
            if (typeof x[k] === "string") {
              return x[k]
                .toLowerCase()
                .includes(this.data.search.toLowerCase());
            } else {
              return false;
            }
          });
        } else {
          return true;
        }
      })
      .filter((x) => {
        // Status
        if (this.data.selectedStatus == "All" || !this.admin) {
          return true;
        } else if (x.status.text == this.data.selectedStatus) {
          return true;
        } else {
          return false;
        }
      })
      .filter((x) => {
        // Tag
        if (this.data.selectedTag == "All" || !this.admin) {
          return true;
        } else if (x.tags && x.tags.some((t) => t.text == this.data.selectedTag)) {
          return true;
        } else {
          return false;
        }
      })
      .sort((a, b) => a.order - b.order);
  }

  async remove(item) {
    await inventoryCollection.doc(`${item.id}`).delete();
  }


  moveItemUp(item, index) {
    const oldOrder = item.order;
    const newOrder = this.inventoryFiltered[index - 1].order;
    inventoryCollection
      .doc(`${this.inventoryFiltered[index].id}`)
      .update({ order: newOrder });
    inventoryCollection
      .doc(`${this.inventoryFiltered[index - 1].id}`)
      .update({ order: oldOrder });
  }

  moveItemDown(item, index) {
    const oldOrder = item.order;
    const newOrder = this.inventoryFiltered[index + 1].order;
    inventoryCollection
      .doc(`${this.inventoryFiltered[index].id}`)
      .update({ order: newOrder });
    inventoryCollection
      .doc(`${this.inventoryFiltered[index + 1].id}`)
      .update({ order: oldOrder });
  }

  async equipmentMoved(changeEvt) {
    // build change list
    const current = this.inventory.map((x) => {
      return {
        id: x.id,
        order: x.order,
      };
    });

    this.swap(current, changeEvt.oldIndex, changeEvt.newIndex);

    // update order
    for(let i = 0; i <= current.length; i++) {
        if ( current[i] != undefined && current[i].order != i) {
          console.log("changing", current[i].order, i);
          // dont await, do them fast as we can
          await inventoryCollection.doc(current[i].id).update({ order: i });
        }
    }
  }

  swap(arr, sourceIndex, destIndex) {
    console.log( 'tmp', arr[destIndex] )
    const tmp = arr[destIndex];
    arr[destIndex] = arr[sourceIndex];
    arr[sourceIndex] = tmp;

    console.log( 'tmp2', arr[destIndex] )
  }

  moveTest(evt, orginalEvent) {
    console.log("moveTest", evt, orginalEvent);
  }
}
